import ChatService from '../services/ChatService.js'
import ChatAppApi from '../api/ChatAppApi.js'

export default class ChatUtil {
  constructor(chatAppUrl, dealerId, pageUrl, baseUrl, adUrl = '', adId = '', realmId = null) {
    this.chatApi = new ChatAppApi(chatAppUrl)
    this.adId = adId
    this.adUrl = adUrl
    this.dealerId = dealerId
    this.pageUrl = pageUrl
    this.baseUrl = baseUrl

    this.TwilioClient = null
    this.userToken = null
    this.conversationId = null
    this.conversation = null

    this.firstName = ''
    this.lastName = ''
    this.email = ''
    this.phoneNumber = ''

    this.realmId = realmId
  }

  async isAgentAvailiable() {
    const agentResponse = await this.chatApi.getAvailableAgentForDealer(this.dealerId)
    return !!agentResponse
  }

  async startGuestConversation() {
    await this.startConversation()
  }

  async startUserConversation(firstName, lastName, email) {
    this.firstName = firstName
    this.lastName = lastName
    this.email = email

    await this.startConversation()
  }

  async startConversation() {
    await this.initializeClient()

    let body = {
      identity: this.userToken.identity,
      dealerId: this.dealerId,
      pageUrl: this.pageUrl,
      baseUrl: this.baseUrl,
      realmId: this.realmId
    }

    body = this.appendAdData(body)
    body = this.appendCustomerData(body)
    this.conversation = await this.chatApi.startConversation(body, this.conversationId)
    await this.chatService.connectToConversationBySid(this.conversation.sid)
  }

  appendCustomerData(object) {
    object.firstName = this.firstName
    object.lastName = this.lastName
    object.email = this.email
    object.phoneNumber = this.phoneNumber
    return object
  }

  appendAdData(object) {
    if (this.adId) {
      object.adId = this.adId
    }

    if (this.adUrl) {
      object.adUrl = this.adUrl
    }

    return object
  }

  async initializeClient() {
    await this.createUserToken()
    await this.connectToChatService()
  }

  async createUserToken() {
    const tokenResult = await this.chatApi.getUserToken(this.email)

    this.userToken = tokenResult
  }

  async connectToChatService() {
    this.chatService = new ChatService(this.userToken.token)
    await this.chatService.connect()
  }

  async createConversation() {
    const response = await this.chatApi.createConversation(this.dealerId, this.adId, this.adUrl, this.realmId)

    this.conversationId = response.id
  }

  isAuthorSelf(author) {
    return this.userToken.identity === author
  }

  submitLeadForm(firstName, lastName, email, phoneNumber, additionalInfo) {
    this.firstName = firstName
    this.lastName = lastName
    this.email = email
    this.phoneNumber = phoneNumber
    this.additionalInfo = additionalInfo

    let body = {
      source: 'customer',
      pageUrl: this.pageUrl,
      baseUrl: this.baseUrl,
      dealerId: this.dealerId,
      additionalInfo: additionalInfo,
      realmId: this.realmId,
      chatAttributes: {
        dealerId: this.dealerId,
        adUrl: this.adUrl,
        pageUrl: this.pageUrl,
        baseUrl: this.baseUrl,
      },
    }

    body = this.appendAdData(body)
    body = this.appendCustomerData(body)

    this.chatApi.createLead(body)
  }
}
